<div>
  <form [formGroup]="form">
    <label [for]="button?.button_id">{{ button?.button_headline }}</label>
    <p *ngIf="button?.button_subhead" class="text-muted">
      {{ button?.button_subhead }}
    </p>
    <md-slider
          #slider
          class="w-100"
          labeled
          range
          [min]="rangeStart"
          [max]="rangeEnd"
          [value-start]="min"
          [value-end]="max"
          (change)="onSliderInput($event, slider)"
        ></md-slider>
    <!-- <md-slider
      class="w-100"
      labeled
      [ticks]="showTicks"
      [step]="step"
      [min]="min"
      [max]="max"
      [value]="form?.get('value')?.value"
      (change)="valueChange($event)"
      [disabled]="button?.button_disable"
    ></md-slider> -->

    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
